module.exports = __webpack_public_path__ + "img/play-yellow.21beebbe.svg";